import type { IExerciseListQueryArgs } from '../../../../redux/api/exercises/exercise-list-query.types';
import type { IExerciseListFilterQuery } from './exercise-list-filter-query';

export function buildExerciseListLazyParams(
  query: IExerciseListFilterQuery,
  pageSize: number,
): Pick<
  IExerciseListQueryArgs,
  | 'searchValue'
  | 'pageSize'
  | 'categoryIds'
  | 'muscleIds'
  | 'equipmentIds'
  | 'developedSkillIds'
> {
  return {
    searchValue: query.searchValue,
    pageSize,
    categoryIds: query.appliedFilters.categories.join(','),
    muscleIds: query.appliedFilters.muscles.join(','),
    equipmentIds: query.appliedFilters.equipment.join(','),
    developedSkillIds: query.appliedFilters.developedSkills.join(','),
  };
}
